import { createSelector } from 'reselect';
import { getFilteredUploadingFiles, getStatus as getStatusDeprecated, getIsFetchingMore as getIsFetchingMoreDeprecated, getCurrentPageOfFoldersAndFiles as getCurrentPageOfFoldersAndFilesDeprecated
// @ts-expect-error Not yet migrated to TS:
} from './FoldersAndFiles';
// @ts-expect-error Not yet migrated to TS:
import { getQueryWithDefaults } from './Query';
// @ts-expect-error Not yet migrated to TS:
import { getPageSize } from './pageSize';
import { selectIsUngatedForBackendPoweredPagination } from 'FileManagerCore/selectors/Auth';
export const getFilesAndFoldersTotal = state => state.filesAndFoldersTable.get('total');
const getStatus = state => state.filesAndFoldersTable.get('status');
export const getFetchFilesAndFoldersRequestStatus = createSelector([selectIsUngatedForBackendPoweredPagination, getStatus, getStatusDeprecated], (isUngatedForBackendPoweredPagination, status, statusDeprecated) => {
  if (!isUngatedForBackendPoweredPagination) {
    return statusDeprecated;
  }
  return status;
});
const getIsFetchingMore = state => !!state.filesAndFoldersTable.get('fetchingMore');
export const getIsFetchingMoreFilesAndFolders = createSelector([selectIsUngatedForBackendPoweredPagination, getIsFetchingMore, getIsFetchingMoreDeprecated], (isUngatedForBackendPoweredPagination, isFetchingMore, isFetchingMoreDeprecated) => {
  if (!isUngatedForBackendPoweredPagination) {
    return isFetchingMoreDeprecated;
  }
  return isFetchingMore;
});
const getObjects = state => state.filesAndFoldersTable.get('objects');
export const getTableFoldersAndFiles = createSelector([getObjects, getFilteredUploadingFiles, getFilesAndFoldersTotal], (fetchedObjects, uploadingFiles, foldersAndFilesTotal) => {
  const total = foldersAndFilesTotal + uploadingFiles.size;
  const objects = uploadingFiles.toList().concat(fetchedObjects);
  return {
    total,
    objects
  };
});
const getCurrentPageOfFoldersAndFilesUngated = createSelector([getTableFoldersAndFiles, getQueryWithDefaults, getPageSize], (allFoldersAndFiles, query, pageSize) => {
  const page = query.page || 1;
  return {
    total: allFoldersAndFiles.total,
    objects: allFoldersAndFiles.objects.slice((page - 1) * pageSize, page * pageSize)
  };
});
export const getCurrentPageOfFoldersAndFiles = createSelector([selectIsUngatedForBackendPoweredPagination, getCurrentPageOfFoldersAndFilesUngated, getCurrentPageOfFoldersAndFilesDeprecated], (isUngatedForBackendPoweredPagination, currentPageOfFoldersAndFiles, currentPageOfFoldersAndFilesDeprecated) => {
  if (!isUngatedForBackendPoweredPagination) {
    return currentPageOfFoldersAndFilesDeprecated;
  }
  return currentPageOfFoldersAndFiles;
});